/**
 * Форматирует сумму в тийинах как сумы с группировкой разрядов:
 * `2500000` → `25 000`. Дробная часть показывается только когда она есть.
 *
 * @returns `—` для отсутствующего значения
 */
export function formatTiyinAsSum(tiyin: number | undefined | null): string {
  if (tiyin === undefined || tiyin === null) return '—';
  return new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 }).format(tiyin / 100);
}
